import { secondsToTimeText } from "../../../../utils/GeneralUtils";

export const genOptionsToSelectTime = () => {
  // イベント時刻設定のセレクトボックスで使うオプションを生成する
  const timeInterval = 1800; // 30分
  const options: Array<[string, string]> = [];

  // 00:00から30分刻み（48通り）
  for (let i = 0; i < 48; i++) {
    options.push([
      (timeInterval * i).toString(),
      secondsToTimeText(timeInterval * i),
    ]);
  }

  return options;
};
